import Vue from 'vue';
import axios from 'axios';
import CpBox from '../box';
import CpBoxContent from '../box-content';
import CpButton from '../button';
import CpButtonLink from '../button-link';
import CpGrid from '../grid';
import CpGridItem from '../grid-item';
import CpIcon from '../icon';
import CpImage from '../image';
import CpPageContent from '../page-content';
import CpRecipient from '../recipient';
import CpToast from '../toast';
import CpTooltip from '../tooltip';
import CpTooltipToggle from '../tooltip-toggle';
import DemocratIcon from '../user-profile/icons/political-party/democrat';
import RepublicanIcon from '../user-profile/icons/political-party/republican';
import LibertarianIcon from '../user-profile/icons/political-party/libertarian';
import GreenIcon from '../user-profile/icons/political-party/green';
import ConstitutionIcon from '../user-profile/icons/political-party/constitution';
import OtherPartyIcon from '../user-profile/icons/political-party/other';
import CpFollowersButton from './buttonProfile';
import CpNewMembers from './newMembers';
import * as fontDirectives from '../directives/font';
import * as marginDirectives from '../directives/margins';
import * as shareDirectives from '../directives/share';
import CpBaseSvgIcon from '../base-svg-icon';
import EndorseIcon from '../social-feed/icons/endorse';

Vue.component('cp-button-connections', CpFollowersButton);

export default {
    components: {
        CpBox,
        CpBoxContent,
        CpButton,
        CpButtonLink,
        CpGrid,
        CpGridItem,
        CpIcon,
        CpImage,
        CpPageContent,
        CpRecipient,
        CpToast,
        CpTooltip,
        CpTooltipToggle,
        RepublicanIcon,
        DemocratIcon,
        LibertarianIcon,
        GreenIcon,
        ConstitutionIcon,
        OtherPartyIcon,
        CpFollowersButton,
        CpNewMembers,
        CpBaseSvgIcon,
        EndorseIcon,
    },

    directives: {
        ...fontDirectives,
        ...marginDirectives,
        ...shareDirectives,
    },

    data() {
        return {
            user: {},
            recipients: [],
            isViewingSelf: false,
            urlCodes: '',
            hasOnlyNull: true,
            toast: null,
        }
    },

    mounted() {
        if (location.hash === '#saved') {
            this.toast = {
                'message': 'Saved!',
                'theme': 'avocado',
            }
            location.hash = "";
        }
    },

    computed: {
        hiddenRecipients() {
            return this.recipients.filter((recipient) => {
                return recipient.visibility_state === 'hidden' || (!recipient.visibility_state && this.user.profile_visibility_state !== 'visible');
            });
        },
        visibleRecipients() {
            return this.recipients.filter((recipient) => {
                return recipient.visibility_state === 'visible' || (!recipient.visibility_state && this.user.profile_visibility_state === 'visible');
            });
        },
        isCustomParty(){
          return this.user.political_party !== 'democrat'
          && this.user.political_party !== 'republican'
          && this.user.political_party !== 'libertarian'
          && this.user.political_party !== 'green'
          && this.user.political_party !== 'constitution'
          && this.user.political_party !== null
        },
    },

    methods: {
        updateRecipient(recipient) {
            axios.post(`/apiv2/user-support/update/${recipient.type}/${recipient.type_id}`,
                {visibility_state: recipient.visibility_state})
                .then((response) => {

                });
        },
        updateProfileVisibility(visibility_state) {
            this.$set(this.user, 'profile_visibility_state', visibility_state);
            axios.post(`/apiv2/user/update`, {profile_visibility_state: visibility_state})
                .then((response) => {

                });

            axios.post(`/apiv2/user-support/update/all`, {visibility_state})
                .then((response) => {
                    this.recipients.map(recipient => recipient.visibility_state = visibility_state);
                });
        },
    }
};
